/**
 * A service implementing domain actions for a payroll entry.
 */
export class PayrollEntryService {
    constructor($http, apexApiUrl) {
        'ngInject';
        this.$http = $http;
        this.apexApiUrl = apexApiUrl;
    }

    /**
     * Return all payroll entries belonging to a particular payroll.
     * @param {number} payrollID The payroll whose entries will be returned.
     * @param {any} query The query parameters passed to filter the results.
     */
    retrievePayrollEntries(payrollID, query) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/payrolls/${payrollID}/entries`,
            params: query
        }).then(response => response.data);
    }

    /**
     * Return the payroll entry manual submissions matching the filter criteria.
     * @param {any} query The filters to the query
     */
    retrievePayrollEntryManualSubmissions(query) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/payroll-entries/all/manual-submissions`,
            params: query
        }).then(response => response.data);
    }


    retrievePayrollEntryManualSubmissionsPage(pageIndex, query) {
        return this.$http.get(this.apexApiUrl + "payroll-entries/all/manual-submissions/page/" + pageIndex || 0, {
            params: query,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Return the payroll entry manual submission for the specific payperiod .
     * @param {any} payPeriodID
     */
    retrievePayrollEntryManualSubmission(payPeriodID) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/payroll-entries/${payPeriodID}/manual-submission`,
        }).then(response => response.data);
    }


    /**
     * Submit a manual request for a particular payroll entry.
     * @param {number} payPeriodID The payroll entry that is being requested manual.
     * @param {any} manualRequest The contents of the manual request.
     */
    submitManualRequest(payPeriodID, manualRequest) {
        return this.$http({
            method: "PUT",
            url: `${this.apexApiUrl}/payroll-entries/${payPeriodID}/manual-submission`,
            data: manualRequest
        });
    }

    /**
     * Patch specific fields of a manual request.
     * @param {number} payPeriodID The payroll entry whose manual request will be updated.
     * @param {any} patch The contents of the patch.
     */
    patchManualRequest(payPeriodID, patch) {
        return this.$http({
            method: "PATCH",
            url: `${this.apexApiUrl}/payroll-entries/${payPeriodID}/manual-submission`,
            data: patch
        });
    }

    /**
     * Cancel the manual request for the payroll entry.
     * @param {number} payPeriodID The payroll entry whose manual request should be cancelled
     */
    cancelManualRequest(payPeriodID) {
        return this.$http({
            method: "DELETE",
            url: `${this.apexApiUrl}/payroll-entries/${payPeriodID}/manual-submission`
        });
    }

    /**
   * Assign the manual request to the given employee
   * @param {number} payPeriodID The payroll entry whose manual request should be assigned
   * @param {number} payPeriodID The employee to whom it needs to be assigned
   */
    assignManualSubmission(payPeriodID, employeeID) {
        return this.$http({
            method: "PUT",
            url: `${this.apexApiUrl}/payroll-entries/${payPeriodID}/manual-request/processors/${employeeID}`
        });
    }

    /**
  * Set the manual request to the pending
  * @param {number} payPeriodID The payroll entry whose manual request should be assigned
  * @param isPending Defines the pending status of manual submission
  */
    saveManualSubmissionPending(payPeriodID, isPending) {
        return this.$http({
            method: "PUT",
            url: `${this.apexApiUrl}/payroll-entries/${payPeriodID}/manual-request/pending/${isPending}`
        });
    }

    /**
* Set the manual request to the active
* @param {number} payPeriodID The payroll entry whose manual request should be assigned
 * @param isWorkingOn Defines the working status of manual submission
*/
    saveManualSubmissionWorking(payPeriodID, isWorkingOn) {
        return this.$http({
            method: "PUT",
            url: `${this.apexApiUrl}/payroll-entries/${payPeriodID}/manual-request/workingon/${isWorkingOn}`
        });
    }

    /**
    * Unassign the given employee from the manual request
    * @param {number} payPeriodID The payroll entry whose manual request should be unassigned
    * @param {number} payPeriodID The employee to whom it needs to be unassigned
    */
    unassignManualSubmission(payPeriodID, employeeID) {
        return this.$http({
            method: "DELETE",
            url: `${this.apexApiUrl}/payroll-entries/${payPeriodID}/manual-request/processors/${employeeID}`
        });
    }

    /**
    * Process the given manual submission
    * @param {number} payPeriodID The payroll entry thats need to be processed
    * @param {any} request A request which decides weather the given payperiod needs to marked as processed or unprocessed
    */
    processManualSubmission(payPeriodID, request) {
        return this.$http({
            method: "PUT",
            url: `${this.apexApiUrl}/payroll-entries/${payPeriodID}/manual-submission/processed`,
            data: request
        });
    }
}
